<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="left"
    >
      <div class="title-container">
        <h3 class="title">萧山区博乐幼儿园</h3>
      </div>

      <el-form-item prop="username">
        <el-input
          ref="username"
          v-model="loginForm.username"
          placeholder="请输入用户名"
          name="username"
          type="text"
          tabindex="1"
          autocomplete="off"
        >
          <i slot="prefix" class="el-input__icon el-icon-user"></i>
        </el-input>
      </el-form-item>

      <el-form-item prop="password">
        <el-input
          :key="passwordType"
          ref="password"
          v-model="loginForm.password"
          :type="passwordType"
          placeholder="请输入密码"
          name="password"
          tabindex="2"
          autocomplete="off"
        >
          <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          <i
            slot="suffix"
            class="el-input__icon"
            :class="
              passwordType === 'password' ? 'el-icon-view' : 'el-icon-hide'
            "
            @click="showPwd"
          ></i>
        </el-input>
      </el-form-item>

      <el-form-item prop="verificationCode">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-input
              v-model="loginForm.verificationCode"
              placeholder="请输入验证码"
              name="verificationCode"
              type="text"
              tabindex="3"
              auto-complete="off"
            >
              <i
                slot="prefix"
                class="el-input__icon el-icon-picture-outline"
              ></i>
            </el-input>
          </el-col>
          <el-col :span="10" v-if="showImgCode">
            <img
              :src="captchaImage"
              alt="verificationCode"
              @click="refreshCaptcha"
              style="
                cursor: pointer;
                height: 40px;
                width: 100%;
                object-fit: cover;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
              "
            />
          </el-col>
        </el-row>
      </el-form-item>

      <!-- <el-form-item class="remember-item">
        <el-checkbox v-model="remember">记住密码</el-checkbox>
      </el-form-item> -->

      <el-button
        :loading="loading"
        type="primary"
        style="width: 100%; margin-bottom: 30px"
        @click.native.prevent="handleLogin"
        >登录</el-button
      >

      <!-- <div class="tips">
        <p>测试账号：11111111111</p>
        <p>测试密码：123456</p>
      </div> -->
    </el-form>
  </div>
</template>

<script>
import { getCaptcha, login } from "@/api/user.js";
import { setToken, getToken, removeToken } from "@/utils/auth.js";

export default {
  name: "Login",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能少于6位"));
      } else {
        callback();
      }
    };
    return {
      captchaImage: "",
      loginForm: {
        username: "",
        password: "",
        verificationCode: "",
        key: "", //图形验证码需要的key
      },
      remember: false,
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
      showImgCode: false, // 展示code码
    };
  },
  created() {
    // 从localStorage获取保存的登录信息,如果用户已经登录，那么重定向到首页
    const token = getToken();
    if (
      token &&
      token !== "undefined" &&
      token !== null &&
      token !== "" &&
      token.trim() !== ""
    ) {
      this.$router.push("/");
    } else {
      this.refreshCaptcha();
    }
  },
  mounted() {
    this.$refs.loginForm.resetFields();
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  methods: {
    refreshCaptcha() {
      getCaptcha()
        .then((res) => {
          this.loginForm.key = res.key;
          this.captchaImage = res.codeImage;
          this.showImgCode = true;
        })
        .catch((err) => {
          console.log("请求图形验证码失败", err);
          this.showImgCode = false;
        });
    },
    showPwd() {
      this.passwordType = this.passwordType === "password" ? "" : "password";
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 接口请求
          login(this.loginForm)
            .then((res) => {
              setToken(res.token);
              // 更新到state
              this.$store.commit("setToken", res.token);
              this.$store.dispatch("getCodeList").then(() => {
                const redirect = this.$route.query.redirect || "/";
                this.$router.push(redirect);
              });
            })
            .catch((err) => {
              // 登录失败以后要刷新验证码
              this.$message.error(err || "登录失败");
              this.refreshCaptcha();
              removeToken();
              localStorage.removeItem("user_permissions");
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.log("请填写完整信息");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$bg: #fff;
$light_gray: #333;
$cursor: #333;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

.login-container {
  min-height: 100vh;
  width: 100%;
  background-color: $bg;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
    "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 35px;
    margin: 0 auto;
    overflow: hidden;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .title-container {
    position: relative;
    text-align: center;
    margin-bottom: 40px;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0 auto 40px auto;
      font-weight: bold;
      font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
        "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
    }
  }

  .el-input {
    display: inline-block;
    height: 47px;
    width: 100%;

    input {
      height: 47px;
      padding-left: 40px;
      background: transparent;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      color: $light_gray;
      caret-color: $cursor;
      font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
        "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;

      &:-webkit-autofill {
        box-shadow: 0 0 0 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    color: #454545;

    &.remember-item {
      border: none;
      background: none;
    }
  }

  .tips {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
    text-align: center;

    p {
      margin: 5px 0;
    }
  }

  .el-checkbox {
    color: #666;
    font-size: 14px;
  }
}
</style>
